import styled from 'styled-components';

export default styled.div`
  display: flex;

  .empty-state {
    width: 180px;
    height: 100%;
    top: 0px;
    right: 0px;
    background: white;
    z-index: 10;
    border-left: 1px solid #CCCCCC;
    box-shadow: -5px 2px 8px rgba(0, 0, 0, 0.1);
    color: #595959;

    .header {
      padding: 35px 15px;
      display: flex;
      
      .content {
        flex: 1;
        
        h1 {
          margin-bottom: 0px;
          font-size: 18px;
        }
      }

      .cont {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .close-cont svg {
        cursor: pointer;
        width: 16px;
        height: 16px;
      }
    }

    .body {
      padding: 0px 15px;
      
      p {
        margin: 0px;
        font-size: 14px;
        line-height: 1.7em;
      }

      .link {
        color: var(--mmt-primary-70);
        font-weight: bold;
      }
    }
  }
`;
